import { ObjectSchema, object, string } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { DutyEngineerFormValue } from '../../models/duty-engineer';
import { addressValidationFields } from '../input-address/input-address-validator';
yup.setLocale(locale);

export function dutyEngineerValidator(): ObjectSchema<DutyEngineerFormValue> {
    return object({
        settingId: string().uuid().nullable().strict(),
        name: string().required().strict().max(20),
        abbreviation: string().required().strict().max(8),
        ...addressValidationFields,
    })
        .strict()
        .noUnknown();
}
